import React from "react";
import { SPINNER } from "src/constants/images";

const CustomSpinner = () => {
  return (
    <span className="custom-spinner">
      <img src={SPINNER.SOURCE} alt="spinner" />
    </span>
  );
};

export default CustomSpinner;
